//
// url-utils.js
//
// Copyright (c) 2014 by Curalate, Inc.
//

/*jshint devel: true, jquery: true */
/*global angular: false, moment: true, window: false, _: false */

(function() {
    "use strict";

    angular.module('curalate').factory('UrlUtils', ['$window',
        function($window) {

            /**
             * Adds the http protocol to the beginning of a URL that is missing a protocol
             * @param url
             * @returns {string} or undefined
             */
            var cleanUrl = function(url) {
                if (url) {
                    var protocolRegex = /^https?:\/\//,
                        url = url.trim();
                    if (!url.match(protocolRegex)) {
                        // Prepend protocol if none is given
                        var start = url.indexOf('//') + 1;
                        return 'http://' + url.slice(start, url.length);
                    } else {
                        return url;
                    }
                }
            };

            /**
             * Parses query parameters. Will return the last value if the same key is used multiple times.
             * @param url The 'search' portion of the url. e.g. ?hello=1. This can be fetched with window.location.search
             * @returns params in an object
             */              
            var getUrlParams = function(url) {
                var urlParams,
                    match,
                    pl     = /\+/g,  // Regex for replacing addition symbol with a space
                    search = /([^&=]+)=?([^&]*)/g,
                    decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
                    query  = url.substring(1);

                urlParams = {};
                while (match = search.exec(query)) {
                    urlParams[decode(match[1])] = decode(match[2]);
                }

                return urlParams;
            };

            var getUrlTrailingId = function() {
                var candidate, idx, path;
                path = $window.location.href;
                candidate = path.substring(path.lastIndexOf('/') + 1);
                idx = candidate.indexOf('?');
                if (idx >= 0) {
                    return candidate.substring(0, idx);
                } else {
                    return candidate;
                }
            };

            return {
                cleanUrl: cleanUrl,
                getUrlParams: getUrlParams,
                getUrlTrailingId: getUrlTrailingId
            };
        }
    ]);

})();
